<template>
    <div>
        <div class="address">
            <address-card
                    :p_name="login_user.name"
                    :p_mobile="login_user.mobile"
                    :p_address="login_user.address_full"
                    @onClick="address_card_click"
            />
        </div>

        <div v-for="(item,index) in list" :key="index">
            <order-select-item :p_info="item" @check_changed="item_check_changed" @real_money_changed="item_money_changed" />
        </div>

        <div>

        </div>
        <div class="fare-box">
            <span class="coupon-info">本单共优惠了￥<span class="val">{{coupon_sum}}</span></span>
            <span class="label">运费￥</span>
            <span class="val">{{fare_val}}</span>
<!--            <span class="info" v-if="fare_val===0">满足包邮条件</span>-->
        </div>

        <van-submit-bar :price="total_money" :loading="submit_loading" button-text="立即支付" @submit="onSubmit">
        </van-submit-bar>

        <!--        用户地址录入-->
        <van-popup v-model="show_edit_address" style="width: 90%;height: 90%">
            <div>
                <van-address-edit
                        :close-on-click-overlay="false"
                        :closeable="true"
                        :show-postal="false"
                        :show-delete="false"
                        show-set-default
                        show-search-result
                        :area-list="areaList"
                        :area-columns-placeholder="['请选择', '请选择', '请选择']"
                        @save="onUserAddressSave"
                />
            </div>
        </van-popup>

    </div>
</template>

<script>
    import AddressCard from "../../components/Order/AddressCard";
    import { mapActions } from 'vuex';
    import OrderSelectItem from "../../components/Order/OrderSelectItem";
    import AreaList from '@/libs/area';
    import AreaListHangzhou from '@/libs/area_hangzhou';

    export default {
        name: "CreateOrderBatch",
        components: {OrderSelectItem,AddressCard},
        data(){
            return{
                login_user:this.$store.getters.getLoginUser,
                coupon_ids:this.$route.params.ids,  //传入的优惠券id
                areaList:this.$route.params.lock_area?AreaListHangzhou:AreaList,    //是否锁定配送区域为杭州市
                list:[],
                show_edit_address:false,
                submit_loading:false,
                no_fare_val:100,    //满多少金额免快递费（设置一个初始值防止出错）
                buy_mode:1,
                product_id:'',
                sales_uid:'',
                group_id:'',
                new_sale_order_id:'',
            }
        },
        computed:{
            coupon_sum(){
                //优惠额合计
                let sum=0;
                for(let i=0;i<this.list.length;i++){
                    if(this.list[i].checked){
                        sum+=parseFloat(this.list[i].coupon_money);
                    }
                }
                if(this.fare_val===0){
                    return sum+this.fare_sum;
                }else{
                    return sum;
                }
            },
            fare_sum(){
                //运费
                let total_fare=0;
                for(let i=0;i<this.list.length;i++){
                    if(this.list[i].checked){
                        total_fare+=parseFloat(this.list[i].fare);
                    }
                }
                return total_fare;
            },
            total_sum(){
                let sum=0;
                for(let i=0;i<this.list.length;i++){
                    if(this.list[i].checked){
                        sum+=parseFloat(this.list[i].price)*parseFloat(this.list[i].order_qty)-parseFloat(this.list[i].coupon_money);
                    }
                }
                return sum;
            },
            fare_val(){
                if(this.total_sum<this.no_fare_val){
                    return this.fare_sum;
                }else{
                    return 0;
                }
            },
            total_money(){
                let sum=this.total_sum+this.fare_val;
                return sum*100; //合计控件中用的是分为单位
            },
        },
        methods:{
            ...mapActions([
                'GetCouponProductList',
                'UpdateUserInfo',
                'GetSystemParam',
                'WeixinCreateOrder',
                'WeixinPayCheck'
            ]),
            item_check_changed(val){
                console.log('选中对象：',val);
                for(let i=0;i<this.list.length;i++){
                    if(this.list[i].id===val.id){
                        this.list[i].checked=val.checked;
                        break;
                    }
                }
            },
            item_money_changed(val){
                console.log('item实付金额发生改变：',val);
                for(let i=0;i<this.list.length;i++){
                    if(this.list[i].id===val.id){
                        this.list[i].order_qty=val.order_qty;
                        break;
                    }
                }
            },
            address_card_click(){
                this.show_edit_address=true;
            },
            loadData(){
                console.log('传入参数coupon_ids',this.coupon_ids);
                if(this.coupon_ids){
                    let coupon_id_list = this.coupon_ids.split(',');
                    this.GetCouponProductList({ids:coupon_id_list}).then(res=>{
                        console.log(res);
                        this.list=res;
                    })
                }
                // 调试用。。。
                // else{
                //     this.coupon_ids='1,2,3,4';
                //     let coupon_id_list = this.coupon_ids.split(',');
                //     this.GetCouponProductList({ids:coupon_id_list}).then(res=>{
                //         console.log(res);
                //         this.list=res;
                //     })
                // }
            },
            getNoFareVal(){
                this.GetSystemParam({key:'no_fare_val'}).then(res=>{
                    console.log(res);
                    this.no_fare_val=res;
                })
            },
            onUserAddressSave(val){
                let data = {
                    'id':this.login_user.id,
                    'province':val.province,
                    'city':val.city,
                    'county':val.county,
                    'address':val.addressDetail,
                    'area_code':val.areaCode,
                    'name':val.name,
                    'mobile':val.tel,
                    'post_code':val.postalCode
                };
                this.UpdateUserInfo(data).then(res=>{
                    if(res.status>0){
                        this.$toast.fail('系统繁忙，请刷新重试！');
                    }else{
                        this.login_user.name=val.name;
                        this.login_user.mobile=val.tel;
                        this.login_user.address=val.addressDetail;
                        this.login_user.address_full=val.province+val.city+val.county+val.addressDetail;
                        this.login_user.province=val.province;
                        this.login_user.city=val.city;
                        this.login_user.county=val.county;
                        this.login_user.area_code=val.area_code;
                        this.login_user.post_code=val.post_code;
                        this.$store.commit('setUser',this.login_user);
                        this.show_edit_address=false;
                    }
                });
            },
            onSubmit(){
                //提交订单
                if(!this.login_user||!this.login_user.id){
                    this.$toast.fail('请先授权微信登录系统！');
                    return;
                }
                if(!this.login_user.mobile||!this.login_user.address){
                    this.$toast.fail('请先完整填写收货人信息！');
                    return;
                }

                this.submit_loading=true;
                //从这里开始继续。。。。(20200809)
                let details=[];
                let coupons=[];
                for(let i=0;i<this.list.length;i++){
                    let orderDetail={
                        'product_id':this.list[i].product_id,
                        'order_qty':this.list[i].order_qty,
                        'price':this.list[i].price,
                        'commission':0,
                        'coupon_val':this.list[i].coupon_money,
                    };
                    details.push(orderDetail);

                    let couponDetail={
                        'product_id':this.list[i].product_id,
                        'coupon_money':this.list[i].coupon_money,
                        'user_coupon_id':this.list[i].id
                    };
                    coupons.push(couponDetail);
                }

                let p={
                    mode:1,
                    // product_id:this.product_id,
                    // qty:this.order_qty,
                    // price:this.final_price,
                    // commission:this.info.commission,
                    client_uid:this.login_user.id,
                    openid:this.login_user.openid,
                    sales_uid:this.sales_uid,
                    product_name:this.list[0].product_name, //取第一个产品名称，用于微信支付接口中产品名称显示
                    address:this.login_user.address_full,
                    customer_name:this.login_user.name,
                    customer_tel:this.login_user.mobile,
                    buy_mode:this.buy_mode,
                    sale_group_id:this.group_id,
                    sale_group_rule_id:this.rule_id,
                    details,
                    coupons,
                    fare_val:this.fare_val,
                };
                this.WeixinCreateOrder(p).then(res=>{
                    if(res.status>0){
                        //失败
                        this.$toast.fail('订单创建失败！');
                        this.submit_loading=false;
                    }else{
                        //成功
                        // console.log('统一订单接口成功！');
                        // console.log(res.responseObject);
                        console.log('新订单id为',res.msg);
                        this.new_sale_order_id=res.msg.toString().split('|')[0];
                        this.group_id=res.msg.toString().split('|')[1];
                        this.weixinPay(res.responseObject);
                    }
                });

            },
            weixinPay(data){
                //调起微信支付
                var vm = this;
                if (typeof window.WeixinJSBridge == "undefined") {
                    if (document.addEventListener) {
                        document.addEventListener("WeixinJSBridgeReady",vm.onBridgeReady(data),false);
                    } else if (document.attachEvent) {
                        document.attachEvent("WeixinJSBridgeReady",vm.onBridgeReady(data));
                        document.attachEvent("onWeixinJSBridgeReady",vm.onBridgeReady(data));
                    }
                } else {
                    vm.onBridgeReady(data);
                }
            },
            onBridgeReady(data){
                let that = this;
                window.WeixinJSBridge.invoke(
                    "getBrandWCPayRequest",
                    data,
                    function(res) {
                        // console.log('----- onBridgeReady 进入------');
                        // console.log(res);
                        if(res.err_msg == "get_brand_wcpay_request:ok"){
                            //支付成功，到后台确认一下
                            let order_id=that.new_sale_order_id;
                            that.WeixinPayCheck({order_id}).then(res=>{
                                if(res.status>0){
                                    console.log('订单支付校验失败！');
                                    //支付服务端校验失败
                                    that.$toast.fail('订单支付状态校验失败，请稍候至我的订单查看!');
                                    //进入我的订单页面（暂时到这里）
                                    // let product_id=that.product_id,sales_uid=that.sales_uid;
                                    // that.$router.push({name:'ProductDetailSale',params:{product_id,sales_uid}});
                                }else{
                                    //支付校验成功，进入支付成功页面
                                    console.log('订单支付校验成功！');
                                    let product_id=that.product_id,sales_uid=that.sales_uid,
                                        buy_mode=that.buy_mode,group_id=that.group_id;
                                    that.$router.push({name:'OrderSuccess',
                                        params:{product_id,sales_uid,order_id,buy_mode,group_id}});
                                }
                            })
                        }else{
                            that.$toast.fail('订单支付失败,请到我的订单中重新支付!');
                            that.$router.push({name:'MyOrderClient'});
                        }
                    }
                );
            },
        },
        mounted() {
            document.body.style.backgroundColor='#F3F4F5';  //设置整页背景色
            this.getNoFareVal();
            this.loadData();
        }

    }
</script>

<style lang="scss" scoped>
    .address{
        padding: 8px;
        text-align: left;
    }
    .fare-box{
        background-color: #FFFFFF;
        padding: 14px;
        text-align: right;
        color: #666666;
        .label{
            font-size: 14px;
        }
        .val{
            color: #E87748;
            font-size: 16px;
            font-weight: bold;
        }
        .info{
            padding-left: 10px;
            font-size: 12px;
            color: #999999;
        }
        .coupon-info{
            float: left;
            font-size: 14px;
            color: #666666;
            .val{
                font-size: 16px;
                color: #666666;
                font-weight: bold;
            }
        }
    }
</style>
